import { Typography, TypographyProps } from '@mui/material';
import { combineSX } from '@/utils/combineSX';
import { DpScrollTitleSX } from '@/components/blocks/DpLibrary/DpScrollTitle/style/style';
import { Linkable } from '@/components/blocks/Linkable';

interface TypografyPropsA extends TypographyProps {
	href?: string;
}

export const DpScrollTitle = ({ children, component, sx, href, ...props }: TypografyPropsA) => (
	<Typography
		component={component || 'h2'}
		sx={combineSX([DpScrollTitleSX, ...(Array.isArray(sx) ? sx : [sx])])}
		{...props}
	>
		<Linkable href={href}>{children}</Linkable>
	</Typography>
);
